<style lang="scss">
  @use "../../../assets/css/design-system/colors";
  @use "../../../assets/css/design-system/utils";
  @use "../../../assets/css/design-system/mixins";

  label {
    all: unset;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;

    .label-text {
      display: flex;
      flex-direction: row;
      gap: 6px;
      padding: 0 utils.in_rem(4px) utils.in_rem(6px) utils.in_rem(4px);

      &.large {
        @include mixins.h4();
      }

      &.small {
        @include mixins.caption();
      }
    }

    .content {
      display: flex;
      flex-direction: row;
      width: 100%;
      gap: utils.in_rem(24px);
    }

    .helper-text {
      display: flex;
      flex-direction: row;
      gap: utils.in_rem(4px);
      padding: utils.in_rem(6px) utils.in_rem(4px) 0 utils.in_rem(4px);
      color: colors.get(textGrey);
      @include mixins.caption();

      &.error {
        color: colors.get(systemError_100);
      }
      &.warning {
        color: colors.get(systemWarning_100);
      }
    }
  }
</style>

<script>
  import IconScale from "../../atoms/IconScale.svelte";
  import SliderInput from "../../atoms/SliderInput.svelte";
  import NumberInput from "../InputFields/NumberInput.svelte";

  export let label = "";
  export let labelSize = "small";
  export let helperText = "";
  export let state = "";

  export let value;
  let { max, min, step, disabled } = $$restProps;

  let cls = "";
  export { cls as class };
  export let style = "";
</script>

<label class={cls} {style}>
  {#if label}
    <div class="label-text {labelSize}">
      <span>{label}</span>
      {#if $$slots.tooltip}
        <IconScale class="fa-circle-info" size="xs" placement="top">
          <span slot="tooltip"><slot name="tooltip" /></span>
        </IconScale>
      {/if}
    </div>
  {/if}
  <div class="content">
    <SliderInput bind:value {...$$restProps} />
    <NumberInput
      style="width:75px"
      bind:value
      {state}
      {max}
      {min}
      {step}
      {disabled}
    />
  </div>
  {#if helperText}
    <span class="helper-text {state}">
      {#if ["error", "warning"].includes(state)}
        <IconScale class="fa-solid fa-circle-info" size="xs" />
      {/if}
      {helperText}
    </span>
  {/if}
</label>
